export const asksBeforeRequired = (next: boolean, usedBy: number): boolean =>
  next && usedBy > 0;

export const filterLeaves = <T extends { leaf: string; folder: string }>(
  leaves: T[],
  folder: string,
  text: string,
): T[] => {
  const needle = text.trim().toLowerCase();
  return leaves.filter(
    (l) =>
      (!folder || l.folder === folder) && l.leaf.toLowerCase().includes(needle),
  );
};
